// Landing page: decorative Orbit hero + a couple of small interactions.
// No recording logic lives here — that's all in record.html / app.ts.
// "Sign in with Fawnroad" is a plain link to /auth/fawnroad/start — no JS
// needed to trigger it, but a returning signed-in user still needs the
// topbar to reflect that (mirrors showApp()'s account-chip swap in app.ts,
// which every other page already does).

import { mountDecorativeOrbit } from './orbit';
import { fetchCurrentUser, logout } from './auth';
import { registerServiceWorker } from './sw-register';

registerServiceWorker();

const orbit = document.getElementById('orbit-decorative');
if (orbit) mountDecorativeOrbit(orbit);

const footerYear = document.getElementById('footer-year');
if (footerYear) footerYear.textContent = String(new Date().getFullYear());

void fetchCurrentUser().then((user) => {
  if (!user) return;
  document.getElementById('fawnroad-signin-btn')?.classList.add('hidden');
  document.getElementById('fawnroad-signin-note')?.classList.add('hidden');
  const chip = document.getElementById('account-chip');
  chip?.classList.remove('hidden');
  const name = document.getElementById('account-name');
  if (name) name.textContent = user.displayName;
  document.getElementById('logout-btn')?.addEventListener(
    'click',
    async () => {
      await logout();
      location.reload();
    },
    { once: true },
  );
});
